import * as React from "react";
const SvgFiRrLocust = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-locust_svg__a)">
      <path
        fill="#062147"
        d="M21.118 13.301C22.482 12.424 24 10.45 24 6.001a1 1 0 1 0-2 0c0 5.82-2.895 5.995-3 6h-3.892l-3.99-8.894a1.91 1.91 0 0 0-1.99-1.092A1.915 1.915 0 0 0 7.463 3.57L5.87 12H3.898L5.42 3.907a1 1 0 0 0-.802-1.832 1.93 1.93 0 0 0-1.156 1.422l-1.601 8.508c-.55.04-1.06.301-1.413.731a1.94 1.94 0 0 0-.413 1.606c.168.864.492 1.665.94 2.376l-.958 5.097a1 1 0 1 0 1.965.37l.68-3.62c.54.41 1.14.744 1.782.986l-.427 2.263A1 1 0 0 0 5.002 23a1 1 0 0 0 .98-.814l.417-2.204q.252.019.509.02h9.599l1.082 2.41a1 1 0 1 0 1.824-.82l-.714-1.59H22c1.299 0 2-1.03 2-2 0-1.929-1.227-3.61-2.882-4.699zm-19.11.7h3.484l-.67 3.544C3.398 16.892 2.317 15.59 2.009 14m4.898 4q-.068 0-.134-.003L7.527 14h2.472a1 1 0 1 0 0-2H7.905l1.484-7.86 5.057 11.27a1 1 0 0 0 1.824-.819l-.265-.59H17c2.25 0 5 1.845 5 4z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-locust_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLocust;
